import type { HttpError } from "@vita-learning/types";

import { getErrorMessage } from "~/shared/utils";

const isHttpError = (e: unknown): e is HttpError => {
	if (!(e && typeof e === "object")) return false;

	if (!("message" in e && typeof e.message === "string")) return false;

	if (!("statusCode" in e && typeof e.statusCode === "number")) return false;

	return true;
};

const isFastApiError = (e: unknown): e is { detail: unknown } => {
	if (!(e && typeof e === "object")) return false;

	if (!("detail" in e)) return false;

	return true;
};

/**
 * @function makeHandleHttpError
 */
export const makeHandleHttpError = (name: string) => {
	const handleHttpError = (e: unknown): HttpError => {
		if (isHttpError(e))
			return {
				name,
				message: e.message,
				statusCode: e.statusCode,
				id: "id" in e && typeof e.id === "string" ? e.id : undefined,
			};

		if (e instanceof Error) {
			if (e.message === "Failed to fetch")
				return {
					message:
						"The network request failed. Check your network connection and try again",
					name,
					statusCode: 503,
					id: "id" in e && typeof e.id === "string" ? e.id : undefined,
				};

			return {
				message: e.message,
				name,
				statusCode:
					"statusCode" in e && typeof e.statusCode === "number"
						? e.statusCode
						: 400,
				id: "id" in e && typeof e.id === "string" ? e.id : undefined,
			};
		}

		// TODO: Enhance error props
		if (isFastApiError(e))
			return {
				name,
				message: getErrorMessage(e.detail),
				id: "INTERNAL_SERVER",
				statusCode: 500,
			};

		return {
			name,
			message: "An internal server error occurred",
			statusCode: 500,
			id: "INTERNAL_SERVER",
		};
	};

	return handleHttpError;
};
